import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import StrategiesAPI from "../../api/StrategiesAPI";
import { useParams, useNavigate } from "react-router-dom";
import { toImagePath } from "../../utils/globalFunctions";

function DetailPlan() {
  const { id } = useParams();
  const numericId = parseInt(id, 10);
  const { i18n } = useTranslation();
  const [details, setDetails] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await (i18n.language === 'en' ? StrategiesAPI.getStrategyEn() : StrategiesAPI.getStrategy());
        const data = response.data;

        // Check if substrategy has an id matching numericId
        const isValidId = data.substrategy?.some((item) => item.order === numericId);

        if (isValidId) {
          setDetails(data);
        } else {
          setDetails(null); // Clear details if ID is not valid
        }
      } catch (error) {
        console.log("StrategiesAPI.getStrategy", error);
        setDetails(null); // Clear details if there's an error
      }
    };

    fetchData();
  }, [numericId, i18n.language]);

  if (!details) {
    return null; // Show Loading UI or spinner while waiting for data
  }

  return (
    <main className="site-main">
      <section className="banner bg-news-intro">
        <img
          className="banner-image w-full"
          src="/images/standards/bg-standards.jpeg"
          alt="Hero Banner"
        />
        <div className="headline text-center">
          <h1 className="headline-title text-3xl md:text-6xl font-bold text-white">
            {details.title}
          </h1>
        </div>
      </section>
      {/* Main Content */}
      <section className="content p-4 md:p-8 bg-gray-50">
        <div className="content-container box-news-container">
          <div className="content-header w-full">
            <div className="header-content">
              <h2 className="header-content__title">
                {details.substrategy
                  ?.filter((item) => item.order === numericId)
                  .map((item, index) => (
                    <div key={index} className="header-content__item">
                      {item.title}
                    </div>
                  ))}
              </h2>
            </div>

            {/* Section: About Office */}
            <section className="about-office mb-6 md:mb-8">
              <div className="relative">
                {details.substrategy
                  ?.filter((item) => item.order === numericId)
                  .map((item, index) => (
                    <div
                      key={index}
                      className="rounded-lg relative group"
                      style={{ position: "relative" }}
                    >
                      {/* Tooltip Replacement */}
                      <div className="absolute bg-gray-700 text-white text-sm rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                        {item.title}
                      </div>
                      <img
                        className="w-screen"
                        style={{ maxWidth: "100%", height: "auto" }}
                        src={toImagePath(item.image.path)}
                        alt={item.image.altText}
                      />
                    </div>
                  ))}
              </div>
              <div className="flex flex-col justify-center gap-3 items-center mt-5">
                {details.substrategy
                  ?.filter((item) => item.order === numericId)
                  .map((item, index) =>
                    item.docfile.map((doc, docIndex) => (
                      <div
                        key={`${index}-${docIndex}`}
                        className="cursor-pointer"
                        onClick={() =>
                          window.open(
                            `${toImagePath(doc.path)}`,
                            "_blank"
                          )
                        }
                      >
                        <button className="flex items-center shadow-lg rounded-md p-4 bg-white border border-gray-200 hover:bg-gray-100 transition-all">
                          <img src="/images/icons/pdf.svg" alt="PDF Icon" />
                          <h5 className="text-blue-900 font-medium pl-2">
                            {doc.title || "Untitled"}
                          </h5>
                        </button>
                      </div>
                    ))
                  )}
              </div>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
}

export default DetailPlan;
